<template>
  <Nav-bar :has_back="!state.isHasBack" :has_right="false" title="充电订单"></Nav-bar>
  <div class="top-margin"></div>
  <div class="container">
    <van-pull-refresh v-model="state.refreshing" @refresh="onRefresh">
      <van-list v-model:loading="state.loading" :finished="state.finished" finished-text="没有更多了" @load="initData">
        <div class="order-item-container" v-for="list in state.list" :key="list.id"
          @click="toDetails(list.status, list.id)">
          <span class="t-f12-c1a">{{
            $filters.timeFormate(list.start_charging_at)
          }}</span>
          <div class="t-f14-c1a font-bold">{{ list.charge_station.name }}</div>
          <div class="t-f12-c66 m-t-5">已充电量: {{ list.total_power || "-" }} 度</div>
          <div class="t-f12-c66">当前计费金额: {{ list.amount || "-" }} 元</div>

          <span class="status-text" :class="list.status">{{
            list.statusName
          }}</span>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import NavBar from "../../components/NavBar.vue";
import { reactive } from "vue";
import { useRouter } from "vue-router";
import request from "@/api/request";
import ordersUtils from "@/utils/data.js";
import httpHelper from "@/helpers/http_helper";
let router;
let state;
let pageCount = 1; //data page
export default {
  components: {
    NavBar: NavBar,
  },
  setup() {
    state = reactive({
      list: [],
      loading: false,
      finished: false,
      isHasBack: false,
      refreshing: false,//下拉刷新状态
    });

    router = useRouter();
    state.isHasBack = window.history.state.back == null
    return { state, toDetails };
  },
  // Vue  destroy
  unmounted() {
    pageCount = 1;
  },
  methods: {
    initData() {
      let filterData = {};
      filterData["page"] = pageCount;
      state.loading = true
      httpHelper.showLoading();

      request.getOrderList(filterData)
        .then((res) => {
          state.refreshing = false
          state.loading = false;
          httpHelper.hideLoading();
          //No more data
          if (res.data.results.length == 0) {
            state.finished = true;
            return;
          }
          // Initialization data
          if (pageCount == 1) {
            state.list.length = 0;
            state.finished = false;
            state.refreshing = false
          }
          //Marge data
          state.list = state.list.concat(formatData(res.data.results));
          //Number of request  page increase
          pageCount++;
        })
        .catch(() => {
          state.loading = false;
          state.refreshing = false
          httpHelper.hideLoading();
        });
    },
    //Pull refresh
    onRefresh() {
      //Reset page
      pageCount = 1;
      state.refreshing = true
      this.initData();
    },
  }
};

//Format  data  of  status
function formatData(list) {
  for (let i = 0; i < list.length; i++) {
    list[i].statusName = ordersUtils.orderStatusName(list[i].status);
  }
  return list;
}
function toDetails(status, id) {
  //If status is  in_progress ,router to  charging pages
  if (status == "in_progress") {
    router.push(`/station/Charging/${id}`);
  } else {
    router.push(`/user/orders_details/${id}`);
  }
}
</script>

<style scoped>
.order-item-container {
  background: #fff;
  border-radius: 5px;
  position: relative;
  padding: 15px;
  flex-direction: column;
  margin: 10px;
}

.status-text {
  font-size: 14px;
  position: absolute;
  top: 15px;
  right: 15px;
}
</style>